import React from 'react';

import { Typography } from 'components/shared/Typography';
import { Icon } from 'components/shared/Icon';

import { CoursePreview } from 'components/CoursePreview';

import type { CatalogContextDisplay } from './catalogContextDisplay';
import { LESSON_TYPE_ICON_SIZE } from './lessonTypeIcons';
import { MODULE_TYPE_ICON_SIZE } from './moduleTypeIcons';

import styles from './TimelineSection.module.scss';

const CATALOG_ICON_SIZE = Math.max(MODULE_TYPE_ICON_SIZE, LESSON_TYPE_ICON_SIZE) + 2;

const CatalogContextBlock = ({
  catalogContext,
}: {
  catalogContext: CatalogContextDisplay;
}) => {
  const {
    icon,
    showCoursePreview,
    coursePreview,
    courseLine,
    moduleLine,
    lessonName,
  } = catalogContext;

  if (!courseLine && !moduleLine && !lessonName) {
    return null;
  }

  return (
    <div className={styles.nodeCatalogContext}>
      {showCoursePreview ? (
        <CoursePreview
          className={styles.nodeCatalogPreview}
          preview={coursePreview}
        />
      ) : icon ? (
        <Icon
          name={icon}
          width={CATALOG_ICON_SIZE}
          height={CATALOG_ICON_SIZE}
          className={styles.nodeCatalogIcon}
          aria-hidden
        />
      ) : (
        <span className={styles.nodeCatalogIconPlaceholder} aria-hidden />
      )}
      <div className={styles.nodeCatalogText}>
        {courseLine ? (
          <Typography
            variant="body3"
            mode="compact"
            className={styles.nodeCatalogCourseLine}
            title={courseLine}
          >
            {courseLine}
          </Typography>
        ) : null}
        {moduleLine ? (
          <Typography
            variant="body3"
            mode="compact"
            className={styles.nodeCatalogModuleLine}
            title={moduleLine}
          >
            {moduleLine}
          </Typography>
        ) : null}
        {lessonName ? (
          <Typography
            variant="body3"
            weight="semiBold"
            mode="compact"
            className={styles.nodeCatalogLessonName}
            title={lessonName}
          >
            {lessonName}
          </Typography>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(CatalogContextBlock);
